import { API_STATUS } from "../../../constants/apiStatus";

export const workoutPlansSliceInitialState = {
  workoutPlans: [],
  selectedPlan: null,
  apiStatus: {
    getUserWorkoutPlans: API_STATUS.IDLE,
  },
  total: 0,
  userId: null,
  error: null,
};
